import { type MouseEvent, useCallback } from "react";

/**
 * The mousedown handler of a toolbar button that leaves the focus where it was, in the editor as a rule.
 * The browser moves the focus on mousedown, before any click handler runs, and a tap ends with the same
 * mousedown. `touchstart` cannot do it: React listens to it as passive, so its `preventDefault` is ignored.
 */
export const useFocusKeepingPress = (
	focusable: boolean | undefined,
	onMouseDown: ((event: MouseEvent<HTMLButtonElement>) => void) | undefined,
) =>
	useCallback(
		(event: MouseEvent<HTMLButtonElement>) => {
			if (!focusable) event.preventDefault();
			onMouseDown?.(event);
		},
		[focusable, onMouseDown],
	);
